import { jsx as l } from "react/jsx-runtime";
const c = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillOpacity: 0.4,
        fillRule: "evenodd",
        d: "M11.991 14.56v-3.347h8.424c.126.567.225 1.098.225 1.845 0 5.139-3.447 8.793-8.64 8.793-4.968 0-9-4.032-9-9s4.032-9 9-9c2.43 0 4.464.89 6.021 2.349l-2.556 2.484c-.648-.612-1.782-1.332-3.465-1.332-2.979 0-5.409 2.475-5.409 5.508s2.43 5.508 5.409 5.508c3.447 0 4.716-2.385 4.95-3.798h-4.959z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  c as default
};
